import { faLightbulb } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TipProps } from "components/tip/types";
import { Component } from "react";
import { connect } from "react-redux";
import t from "translations/translator";
import { AppState } from "types/app";
import "./Tip.css";

const mapStateToProps = (state:AppState):TipProps.Redux => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
	};
};

class Tip extends Component<TipProps.Component> {
	render():JSX.Element{
		return (
			<p className="tip"><FontAwesomeIcon icon={faLightbulb} />{t.t("Tip")}: {t.t(this.props.text, this.props.placeholders)}</p>
		);
	}
}
export default connect(mapStateToProps)(Tip);
